import ContrastIcon from '@mui/icons-material/Contrast';
import { useTheme } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import React, { useContext } from 'react';

import { setCookie } from '../../../../../../utils/cookie';
import { toHumanReadable } from '../../../../../../utils/stringUtils';
import { MenuContext } from '../../MenuContext';

import { useThemeSelectorStyles } from './styleSelectorStyles';
import ThemeEnum, { getThemeEnum } from './themeEnum';

export const ThemeSelector = () => {
  const menuContext = useContext(MenuContext);
  const theme = useTheme();
  const styles = useThemeSelectorStyles(theme, menuContext.selectedTheme);
  const themeEnum = ThemeEnum[getThemeEnum()];

  const title = toHumanReadable(themeEnum);

  const getMinMaxOfEnum = (e: object) => {
    const values = Object.keys(e)
      .map((k) => (k === '' ? NaN : +k))
      .filter((k) => !isNaN(k))
      .sort((k1, k2) => k1 - k2);

    return [values[0], values[values.length - 1]];
  };

  const handleClick = () => {
    let selectedThemeInt = menuContext.selectedTheme;

    const [min, max] = getMinMaxOfEnum(ThemeEnum);

    if (selectedThemeInt < max) {
      selectedThemeInt++;
      menuContext.setSelectedTheme(selectedThemeInt);
    } else {
      selectedThemeInt = min;
      menuContext.setSelectedTheme(selectedThemeInt);
    }

    const expiryTime = 365;

    setCookie('theme', `${selectedThemeInt}`, expiryTime);
    // navigateToUrl("/");
    window.location.replace('/');

    window.location.reload();
  };

  return (
    <Tooltip title={title} placement="bottom-start">
      <IconButton
        aria-label={title}
        className={`theme-selector-button ${styles.button}`}
        disableRipple
        onClick={handleClick}
      >
        <ContrastIcon className={styles.themeIcon} />
      </IconButton>
    </Tooltip>
  );
};
